import * as React from "react";
import TrackingPage from "./TrackingPage";
import { LogoutOutlined } from "@ant-design/icons";
import { death } from "../../graphql/auth";

interface IDashboardPageProps { }

const DashboardPage: React.FunctionComponent<IDashboardPageProps> = (props) => {
  return (
    <div className="bg-neutral-L30 flex h-[100vh] flex-col">
      {/* <div className="absolute z-10 top-[10px] left-[10px] desktop:hidden">
        <div className="w-[150px]">
          <img src={LOGO_BLACK_IMAGE} alt="logo" />
        </div>
      </div> */}
      <div className="absolute z-10 top-[10px] right-[0px]">
        <div
          onClick={death}
          className="flex items-center gap-[8px] px-[16px]  hover:!bg-neutral-L30 hover:!font-7 text-neutral-D90 transition duration-500 cursor-pointer"
        >
          <LogoutOutlined color="#fff"/>
        </div>
      </div>
      <TrackingPage />
    </div>
  );
};

export default DashboardPage;
